import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Channel, Provider } from "@/types";
import { ChannelType, ProviderConfig } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type CreateChannelInput = {
  name: string;
  type: ChannelType;
  provider: Provider;
  config?: ProviderConfig;
};

export const useCreateChannel = (
  projectId: string,
  options: Omit<UseMutationOptions<Channel, UnprocessableEntityError, CreateChannelInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Channel, UnprocessableEntityError, CreateChannelInput, unknown>({
    mutationFn: async (input: CreateChannelInput): Promise<Channel> => {
      const response = await api.post<Channel>(`/projects/${projectId}/channels`, underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["projects", projectId, "channels"],
      });
    },
    ...options
  });
};
